import { Box, Button, Center, Heading, Stack, Text, useDisclosure } from '@chakra-ui/react';
import { LoginModal } from '../../components/LoginModal';
import { NavLink } from 'react-router-dom';
import { NewAccountModal } from '../../components/NewAccountModal';
import { useAuthState, useSignOut } from 'react-firebase-hooks/auth';
import { useFirebaseAuth } from '../../hooks/useFirebaseAuth';
import { useUserClaims } from '../../hooks/useUserClaims';

export const ClientView = (props: any) => {
	const auth = useFirebaseAuth();
	const [user, loading, error] = useAuthState(auth);
	const [userClaims] = useUserClaims(auth);
	const [signOut] = useSignOut(auth);
	const { open: isLoginOpen, onOpen: onLoginOpen, onClose: onLoginClose } = useDisclosure();
	const { open: isNewAccountOpen, onOpen: onNewAccountOpen, onClose: onNewAccountClose } = useDisclosure();

	const handleLogout = async () => {
		try {
			await signOut();
		} catch (err) {
			console.error(err);
		}
	};

	if (loading) {
		return <>'Loading'</>;
	}
	if (error) {
		console.error(error)
		return <>'Error'</>
	}

	if (!user) {
		return (
			<>
				<Center mt={20}>
					<Box>
						{/* Jeśli juz jesteś naszym klientem: */}
						<Button onClick={onLoginOpen}>Zaloguj się</Button>
						{/* W przeciwnym razie: */}
						<Text display="inline" p={5}>
							lub
						</Text>
						<Button onClick={onNewAccountOpen}>Załóż konto</Button>
					</Box>
				</Center>
				<LoginModal isOpen={isLoginOpen} onClose={onLoginClose} />
				<NewAccountModal isOpen={isNewAccountOpen} onClose={onNewAccountClose} />
			</>
		);
	} else if (!!userClaims?.admin) {
		return (
            <>
                <Center mt={20}>
					<Stack>
						<Text p={5} textAlign="center">
							Jesteś aktualnie zalogowany(a) jako administrator:
							<Heading as='p'size="md">
								{user?.displayName || user.email}
							</Heading>
						</Text>
						<Text p={5} textAlign="center" fontStyle="italic">
							Jeśli chcesz zapisać klienta przez panel administracyjny <br /> (przez dopisanie klienta do terminu)
						</Text>
						<Button onClick={handleLogout}>Wyloguj</Button>
						<Button asChild mt={2} colorPalette="orange">
							<NavLink to="/admin/terminy">Przejdź do panelu</NavLink>
						</Button>
					</Stack>
				</Center>
            </>
        );
	} else if (!!userClaims?.tutor) {
		return (
            <>
                <Center mt={20}>
					<Stack>
						<Text p={5} textAlign="center">
							Jesteś aktualnie zalogowany(a) jako korepetytor:
							<Heading as='p' size="md">
								{user?.displayName || user.email}
							</Heading>
						</Text>
						<Button onClick={handleLogout}>Wyloguj</Button>
					</Stack>
				</Center>
            </>
        );
	} else {
		return (
            <>
                <Center mt={20}>
					<Stack>
						<Text p={5} textAlign="center">
							Jesteś aktualnie zalogowany(a) jako:
							<Heading as='p' size="md">
								{user?.displayName || user.email}
							</Heading>
						</Text>
						<Button onClick={handleLogout}>Wyloguj</Button>
						<Button mt={2} colorPalette="orange" onClick={props.onStepFinish}>Dalej</Button>
					</Stack>
				</Center>
            </>
        );
	}
};
